import { connect } from 'react-redux';
import View from './LifeExpectanciesView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  LIFE_EXPECTANCIES_WHAT_IF_KEY,
  LIFE_EXPECTANCIES_WHAT_IF_PATH,
} from './LifeExpectanciesConstants';
import {
  principalName,
  partnerName,
  hasPartner,
  principalOptions,
  partnerOptions,
  principalLifeExpectancySelector,
  partnerLifeExpectancySelector,
} from './LifeExpectanciesSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  planImpact,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  isOPLMonteCarloSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  principalName: principalName(state, ownProps),
  partnerName: partnerName(state, ownProps),
  hasPartner: hasPartner(state, ownProps),
  principalOptions: principalOptions(state, ownProps),
  partnerOptions: partnerOptions(state, ownProps),
  principalLifeExpectancy: principalLifeExpectancySelector(state, ownProps),
  partnerLifeExpectancy: partnerLifeExpectancySelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  storeData: goalId => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, LIFE_EXPECTANCIES_WHAT_IF_KEY, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        LIFE_EXPECTANCIES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        LIFE_EXPECTANCIES_WHAT_IF_KEY,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        LIFE_EXPECTANCIES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        LIFE_EXPECTANCIES_WHAT_IF_KEY,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId) => {
    dispatch(
      fetchWhatIfOptions(
        clientId,
        fpId,
        goalId,
        LIFE_EXPECTANCIES_WHAT_IF_PATH,
        LIFE_EXPECTANCIES_WHAT_IF_KEY,
      ),
    );
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        LIFE_EXPECTANCIES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        LIFE_EXPECTANCIES_WHAT_IF_KEY,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
